import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { toast } from 'react-toastify';
import { Helmet } from 'react-helmet';

function ProfileInformation() {
    const [firstName, setFirstName] = useState('');
    const [middleName, setMiddleName] = useState('');
    const [lastName, setLastName] = useState('');
    const [preferredFirstName, setPreferredFirstName] = useState('');
    const [hostPhoneNumber, setHostPhoneNumber] = useState('');
    const [hostEmail, setHostEmail] = useState('');
    const [hostAddressStreet, setHostAddressStreet] = useState('');
    const [hostApartment, setHostApartment] = useState('');
    const [hostCountry, setHostCountry] = useState('');
    const [hostState, setHostState] = useState('');
    const [hostCity, setHostCity] = useState('');
    const [countryList, setCountryList] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [visibleSection, setVisibleSection] = useState(null);
    const [formErrors, setFormErrors] = useState({});

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10}$/;

    useEffect(() => {
        fetchProfileData();
        fetchCounryList();
    }, []);

    const fetchProfileData = async () => {
        const hostData = getItemFromLocalStorage('hostProfile');
        let formData = new FormData();
        formData.append('token', hostData.host_access_token);

        try {
            const response = await axios({
                method: 'post',
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                url: `${params.baseURL}${params.endpoints.getExtraProfile}`,
                data: formData
            });

            console.log(response.data)

            if (response.data.status === 'found') {
                const profile_data = response.data.profile_data;
                setFirstName(profile_data.first_name || '');
                setMiddleName(profile_data.middle_name || '');
                setLastName(profile_data.last_name || '');
                setPreferredFirstName(profile_data.preferred_first_name || '');
                setHostPhoneNumber(profile_data.host_phone_number_multiple || '');
                setHostEmail(profile_data.host_email || '');
                setHostAddressStreet(profile_data.host_address_street || '');
                setHostApartment(profile_data.host_apartment || '');
                setHostCountry(profile_data.host_country || '');
                setHostState(profile_data.host_state || '');
                setHostCity(profile_data.host_city || '');
                fetchStateList(profile_data.host_country || '', profile_data.host_state, profile_data.host_city)
                fetchCityList(profile_data.host_state,profile_data.host_country)
            } else {
                console.log('An error occurred while fetching data.');
            }
        } catch (err) {
            console.log(err.message);
        }
    };

    const fetchCounryList = async () => {
        try {
            const response = await axios({
                method: 'post',
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                url: `${params.baseURL}${params.endpoints.countryList}`,
            });

            if (response.data.status === 'ok') {
                setCountryList(response.data.country_list);
            } else {
                console.log('An error occurred while fetching data.');
            }
        } catch (err) {
            console.log(err.message);
        }
    };

    const fetchStateList = async (countryId, defaultState = "", defaultCity = "") => {
        let formData = new FormData();
        formData.append('country_id', countryId);

        try {
            const response = await axios({
                method: 'post',
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                url: `${params.baseURL}${params.endpoints.stateList}`,
                data: formData
            });

            if (response.data.status === 'ok') {
                setStateList(response.data.state_list);
                setCityList([]);
                if (!defaultState) {
                    setHostState('');
                }
                if (!defaultCity) {
                    setHostCity('');
                }

            } else {
                console.log('An error occurred while fetching data.');
            }
        } catch (err) {
            console.log(err.message);
        }
    };

    const fetchCityList = async (stateId,defaultCountry="") => {
        let formData = new FormData();
        formData.append('country_id', defaultCountry ? defaultCountry : hostCountry);
        formData.append('state_id', stateId);

        try {
            const response = await axios({
                method: 'post',
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                url: `${params.baseURL}${params.endpoints.cityList}`,
                data: formData
            });

            if (response.data.status === 'ok') {
                setCityList(response.data.city_list);
            } else {
                console.log('An error occurred while fetching data.');
            }
        } catch (err) {
            console.log(err.message);
        }
    };

    const handleCountryChange = (e) => {
        const countryId = e.target.value;
        setHostCountry(countryId);
        fetchStateList(countryId);
    };

    const handleStateChange = (e) => {
        const stateId = e.target.value;
        setHostState(stateId);
        fetchCityList(stateId);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        switch (name) {
            case 'firstName':
                setFirstName(value);
                setFormErrors((prev) => ({ ...prev, firstName: !value }));
                break;
            case 'middleName':
                setMiddleName(value);
                break;
            case 'lastName':
                setLastName(value);
                setFormErrors((prev) => ({ ...prev, lastName: !value }));
                break;
            case 'preferredFirstName':
                setPreferredFirstName(value);
                break;
            case 'hostPhoneNumber':
                if (/^\d*$/.test(value)) {
                    setHostPhoneNumber(value);
                    setFormErrors((prev) => ({
                        ...prev,
                        hostPhoneNumber: !phoneRegex.test(value),
                    }));
                }
                break;
            case 'hostEmail':
                setHostEmail(value);
                setFormErrors((prev) => ({
                    ...prev,
                    hostEmail: !emailRegex.test(value),
                }));
                break;
            case 'hostAddressStreet':
                setHostAddressStreet(value);
                setFormErrors((prev) => ({ ...prev, hostAddressStreet: !value }));
                break;
            case 'hostApartment':
                setHostApartment(value);
                break;
            default:
                break;
        }
    };

    const validateSection = (section) => {
        const errors = {};
        if (section === 'legal') {
            if (!firstName) errors.firstName = true;
            if (!lastName) errors.lastName = true;
        }
        if (section === 'contact') {
            if (!phoneRegex.test(hostPhoneNumber)) errors.hostPhoneNumber = true;
        }
        if (section === 'email') {
            if (!emailRegex.test(hostEmail)) errors.hostEmail = true;
        }
        if (section === 'address') {
            if (!hostAddressStreet) errors.hostAddressStreet = true;
        }
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSectionSave = async (section, e) => {
        e.preventDefault();
        if (!validateSection(section)) {
            return;
        }

        const hostData = getItemFromLocalStorage('hostProfile');
        let formData = new FormData();
        formData.append('token', hostData.host_access_token);
        formData.append('first_name', firstName);
        formData.append('middle_name', middleName);
        formData.append('last_name', lastName);
        formData.append('preferred_first_name', preferredFirstName);
        formData.append('host_email', hostEmail);
        formData.append('host_address_street', hostAddressStreet);
        formData.append('host_apartment', hostApartment);
        formData.append('host_country', hostCountry);
        formData.append('host_state', hostState);
        formData.append('host_city', hostCity);
        formData.append('host_phone_number_multiple', hostPhoneNumber);

        try {
            const response = await axios.post(
                `${params.baseURL}${params.endpoints.updateExtraProfile}`,
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            if (response.data.status === 'ok') {
                toast.success('Profile saved successfully');
            }
        } catch (err) {
            console.log(err.message);
        }
    };

    const toggleSection = (section) => {
        setVisibleSection(visibleSection === section ? null : section);
    };

    return (
        <div>
            <Helmet>
                <title>Profile Information</title>
                <meta name='description' content='' />
            </Helmet>
            <div className="personal-section">
                <div className="row">
                    <div className='col-md-6 split-section' style={{ backgroundImage: "url('/assets/img/listing/step21.png')" }}>

                    </div>
                    <div className='col-md-6 offset-md-6 split-second-part'>
                        <form id="personal-information-form">
                            {/*<div className="banner-msg">
                                <img className="pi-banner img-fluid" src={`${params.profileUrl}/guest/banners/profile_information_banner.png`} alt="" />
                            </div>*/}

                            <div className="txt-msg btxt hcode-msg mb-5">
                                <p className="pid">Wire Stay collects your personal information to verify your identity and ensure a smooth and fast approval process for onboarding to the Wire Stay host platform.</p>
                            </div>

                            <div className="section">
                                <div className="pidbox" id="legalSection">
                                    <div className="pidtxt">
                                        <img class="pid-img" src={'/assets/img/icons/spotlight_white_icon.png'} alt="" />
                                        <p>Host Spotlight</p>
                                    </div>
                                    <a href="/profile/spotlight" className="edit-btn">
                                        <img src={'/assets/img/icons/edit_black_icon.svg'} alt="" />
                                    </a>
                                </div>
                                <span class="line"></span>
                            </div>

                            <div className="section">
                                <div className="pidbox" id="legalSection">
                                    <div className="pidtxt">
                                        <img class="pid-img" src={'/assets/img/icons/legal_name_white_icon.png'} alt="" />
                                        <p>Legal name</p>
                                    </div>
                                    <a href="javascript:void(0);" className="edit-btn" onClick={() => toggleSection('legal')}>
                                        <img src={'/assets/img/icons/edit_black_icon.svg'} alt="" />
                                    </a>
                                </div>
                                {visibleSection === 'legal' && (
                                    <div className='form-fields mt-4'>
                                        <div className="form-group">
                                            <div className="form-floating mb-3">
                                                <input className={`form-control ${formErrors.firstName ? 'is-invalid' : ''}`} type="text" id="firstName" name="firstName" value={firstName} onChange={handleChange} onKeyUp={handleChange} onKeyDown={(e) => {
                                                    if (e.key === " ") e.preventDefault();
                                                }} />
                                                <label htmlFor="firstName">First Name on ID</label>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="form-floating mb-3">
                                                <input className={`form-control ${formErrors.middleName ? 'is-invalid' : ''}`} type="text" id="middleName" name="middleName" value={middleName} onChange={handleChange} onKeyUp={handleChange} />
                                                <label htmlFor="middleName">Middle Name on ID</label>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="form-floating mb-3">
                                                <input className={`form-control ${formErrors.lastName ? 'is-invalid' : ''}`} type="text" id="lastName" name="lastName" value={lastName} onChange={handleChange} onKeyUp={handleChange} />
                                                <label htmlFor="lastName">Last Name on ID</label>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <button className="wt-btn" onClick={(e) => handleSectionSave('legal', e)}>Save</button>
                                        </div>
                                    </div>
                                )}
                                <span class="line"></span>
                            </div>

                            <div className="section">
                                <div className="pidbox" id="preferred">
                                    <div className="pidtxt">
                                        <img class="pid-img" src={'/assets/img/icons/legal_name_white_icon.png'} alt="" />
                                        <p>Host Preferred Name</p>
                                    </div>
                                    <a href="javascript:void(0);" className="edit-btn" onClick={() => toggleSection('preferred')}>
                                        <img src={'/assets/img/icons/edit_black_icon.svg'} alt="" />
                                    </a>
                                </div>
                                {visibleSection === 'preferred' && (
                                    <div className='form-fields mt-4'>
                                        <div className="form-group">
                                            <div className="form-floating mb-3">
                                                <input className={`form-control ${formErrors.preferredFirstName ? 'is-invalid' : ''}`} type="text" id="preferredFirstName" name="preferredFirstName" value={preferredFirstName || firstName} onChange={handleChange} onKeyUp={handleChange} />
                                                <label htmlFor="preferredFirstName">Host Preferred Name</label>
                                            </div>
                                        </div>
                                        <div className="txt-msg hcode-msg">
                                            <p className="pid">The first name or business name that you'd like to go by on Wirestay.</p>
                                        </div>
                                        <div className="form-group">
                                            <button className="wt-btn" onClick={(e) => handleSectionSave('preffered', e)}>Save</button>
                                        </div>
                                    </div>
                                )}
                                <span class="line"></span>
                            </div>

                            <div className="section">
                                <div className="pidbox" id="contact">
                                    <div className="pidtxt">
                                        <img class="pid-img" src={'/assets/img/icons/contact_white_icon.png'} alt="" />
                                        <p>Phone Number</p>
                                    </div>
                                    <a href="javascript:void(0);" className="edit-btn" onClick={() => toggleSection('contact')}>
                                        <img src={'/assets/img/icons/edit_black_icon.svg'} alt="" />
                                    </a>
                                </div>
                                {visibleSection === 'contact' && (
                                    <div className='form-fields mt-4'>
                                        <div className="form-group">
                                            <div className="form-floating mb-3">
                                                <input className={`form-control ${formErrors.hostPhoneNumber ? 'is-invalid' : ''}`} type="tel" id="hostPhoneNumber" name="hostPhoneNumber" value={hostPhoneNumber} onChange={handleChange} onKeyUp={handleChange} maxLength={10} />
                                                <label htmlFor="hostPhoneNumber">Number</label>
                                            </div>
                                        </div>
                                        <div className="txt-msg hcode-msg">
                                            <p className="pid">Contact number (for Wire Stay to get in touch).</p>
                                        </div>
                                        <div className="form-group">
                                            <button className="wt-btn" onClick={(e) => handleSectionSave('contact', e)}>Save</button>
                                        </div>
                                    </div>
                                )}
                                <span class="line"></span>
                            </div>

                            <div className="section">
                                <div className="pidbox" id="email">
                                    <div className="pidtxt">
                                        <img class="pid-img" src={'/assets/img/icons/email_white_icon.png'} alt="" />
                                        <p>Email</p>
                                    </div>
                                    <a href="javascript:void(0);" className="edit-btn" onClick={() => toggleSection('email')}>
                                        <img src={'/assets/img/icons/edit_black_icon.svg'} alt="" />
                                    </a>
                                </div>
                                {visibleSection === 'email' && (
                                    <div className='form-fields mt-4'>
                                        <div className="form-group">
                                            <div className="form-floating mb-3">
                                                <input className={`form-control ${formErrors.hostEmail ? 'is-invalid' : ''}`} type="text" id="hostEmail" name="hostEmail" value={hostEmail} onChange={handleChange} onKeyUp={handleChange} />
                                                <label htmlFor="hostEmail">Email</label>
                                            </div>
                                        </div>
                                        <div className="txt-msg hcode-msg">
                                            <p className="pid">Use an address you'll always have access to.</p>
                                        </div>
                                        <div className="form-group">
                                            <button className="wt-btn" onClick={(e) => handleSectionSave('email', e)}>Save</button>
                                        </div>
                                    </div>
                                )}
                                <span class="line"></span>
                            </div>

                            <div className="section">
                                <div className="pidbox" id="address">
                                    <div className="pidtxt">
                                        <img class="pid-img" src={'/assets/img/icons/address_white_icon.png'} alt="" />
                                        <p>Address</p>
                                    </div>
                                    <a href="javascript:void(0);" className="edit-btn" onClick={() => toggleSection('address')}>
                                        <img src={'/assets/img/icons/edit_black_icon.svg'} alt="" />
                                    </a>
                                </div>
                                {visibleSection === 'address' && (
                                    <div className='form-fields mt-4'>
                                        <div className="form-group">
                                            <div className="form-floating mb-3">
                                                <input className={`form-control ${formErrors.hostAddressStreet ? 'is-invalid' : ''}`} type="text" id="hostAddressStreet" name="hostAddressStreet" value={hostAddressStreet} onChange={handleChange} onKeyUp={handleChange} />
                                                <label htmlFor="hostAddressStreet">Street</label>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="form-floating mb-3">
                                                <input className={`form-control ${formErrors.hostApartment ? 'is-invalid' : ''}`} type="text" id="hostApartment" name="hostApartment" value={hostApartment} onChange={handleChange} onKeyUp={handleChange} />
                                                <label htmlFor="hostApartment">Apt Suite (optional)</label>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="form-floating mb-3">
                                                <select
                                                    className="form-control country-code"
                                                    id='hostCountry'
                                                    name='hostCountry'
                                                    value={hostCountry}
                                                    onChange={handleCountryChange}
                                                >
                                                    <option value="">Select Country</option>
                                                    {countryList.map((code, index) => (
                                                        <option key={index} value={code.country_id}>
                                                            {code.country_name}
                                                        </option>
                                                    ))}
                                                </select>
                                                <label htmlFor="hostCountry">Country</label>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <div className="form-floating mb-3">
                                                <select
                                                    id="hostState"
                                                    name="hostState"
                                                    value={hostState}
                                                    onChange={handleStateChange}
                                                    className="form-control"
                                                    disabled={!hostCountry}
                                                >
                                                    <option value="">Select State</option>
                                                    {stateList.map((state) => (
                                                        <option key={state.state_id} value={state.state_id}>
                                                            {state.state_name}
                                                        </option>
                                                    ))}
                                                </select>
                                                <label htmlFor="hostState">State</label>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <div className="form-floating mb-3">
                                                <select
                                                    id="hostCity"
                                                    name="hostCity"
                                                    value={hostCity}
                                                    onChange={(e) => setHostCity(e.target.value)}
                                                    className="form-control"
                                                    disabled={!hostState}
                                                >
                                                    <option value="">Select City</option>
                                                    {cityList.map((city) => (
                                                        <option key={city.city_id} value={city.city_id}>
                                                            {city.city_name}
                                                        </option>
                                                    ))}
                                                </select>
                                                <label htmlFor="hostCity">City</label>
                                            </div>
                                        </div>

                                        <div className="txt-msg hcode-msg">
                                            <p className="pid">Kindly provide your communication address for future correspondence.</p>
                                        </div>
                                        <div className="form-group">
                                            <button className="wt-btn" onClick={(e) => handleSectionSave('address', e)}>Save</button>
                                        </div>
                                    </div>
                                )}
                                <span class="line"></span>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProfileInformation